import styled, { css } from 'styled-components';

/* ── Agent Collapsible Blocks ───────────────────────────────────── */

export const AgentBlockWrapper = styled.div<{ $accentColor?: string }>`
  border-radius: 1rem;
  margin: ${({ theme }) => theme.spacing.level2} 0;
  overflow: hidden;
  border: 1px solid ${({ theme, $accentColor }) => $accentColor || theme.colors.outlineVariant};
  width: 100%;
`;

export const AgentBlockHeader = styled.button<{ $accentColor?: string; $onAccentColor?: string }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level3};
  width: 100%;
  padding: ${({ theme }) => theme.spacing.level4} ${({ theme }) => theme.spacing.level5};
  border: none;
  color: ${({ theme, $onAccentColor, $accentColor }) =>
    $onAccentColor || ($accentColor ? '#ffffff' : theme.colors.onSurface)};
  ${({ theme }) => theme.font.bodyMedium};
  line-height: 1.5;
  cursor: pointer;
  user-select: none;
  text-align: left;

  ${({ theme: { colors }, $accentColor }) =>
    `background: ${$accentColor || colors.surfaceContainerLow};`}

  ${({ $accentColor }) => $accentColor && css`
    & > * {
      color: inherit;
    }
  `}

  &:hover {
    filter: brightness(${({ theme: { isLightTheme } }) => (isLightTheme ? '0.96' : '1.15')});
  }
`;

export const AgentBlockChevron = styled.span<{ $expanded: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: auto;
  transition: transform 200ms ease;
  transform: rotate(${({ $expanded }) => ($expanded ? '180deg' : '0deg')});
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;

export const AgentBlockHeaderIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.onSurface};
  opacity: 0.85;
`;

export const AgentBlockContent = styled.div<{ $expanded: boolean }>`
  max-height: ${({ $expanded }) => ($expanded ? '100000px' : '0')};
  overflow: hidden;
  transition: max-height 300ms ease;
  padding: ${({ $expanded, theme }) => ($expanded ? `${theme.spacing.level4} ${theme.spacing.level5} ${theme.spacing.level5}` : `0 ${theme.spacing.level5}`)};
`;

/* ── Compact Agent Block (non-collapsible, for silent agents) ──── */

export const CompactAgentBlockBar = styled.div<{ $accentColor?: string }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.level3};
  width: 100%;
  padding: ${({ theme }) => theme.spacing.level3} ${({ theme }) => theme.spacing.level5};
  border-radius: 1rem;
  margin: ${({ theme }) => theme.spacing.level2} 0;
  border: 1px solid ${({ theme, $accentColor }) => $accentColor || theme.colors.outlineVariant};
  color: ${({ theme, $accentColor }) => ($accentColor ? '#ffffff' : theme.colors.onSurface)};
  ${({ theme }) => theme.font.bodyMedium};
  line-height: 1.5;
  user-select: none;

  ${({ theme: { colors }, $accentColor }) =>
    `background: ${$accentColor || colors.surfaceContainerLow};`}

  ${({ $accentColor }) =>
    $accentColor &&
    css`
      & > * {
        color: inherit;
      }
    `}
`;

export const CompactAgentBlockCheck = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: auto;
  opacity: 0.7;
`;
